var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_132_3",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_132_3",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD6UlEQVR4nO2dzatVVRiHHxGjgdUNwcomfmSZBwdamBKSoxpJYAMr/wdB00mgONM/IKTC7IMQM6Kyj0n0D6RDizCtuKWgJTpQC7zdJQvey94dzr177bPvXvu95/weeEcu9nnf9fiyP9Ze+4IQQgghhBBCCCGEECIXm4B9Fhs17d1xH/AREPriA/s3kVnGlwNkzMS3wP0y4kNGkBR/MoKk+JMRJMWfjCAp/mQESZlfGV/MgwxJcSgjqFP8yQiS4k9GkBR/MoKk+JMRJGV2FgGf1JjEO/M0ZiZOWQ7C2Flj8q4kjt9pY1OP+7JsFHxYQ8Y6oJcwtmdjU6W8LyEFn9eQQQ0h1JDymY0XwKEaMuoKSZVysDR+7HkEuJooYxghVVLiby8fewsD1sZ/6Zuos8DqARM1jJDIGuBc37gLWoufncXAdmA3sGWOS9FhhWDH3Gq/sd1+UzSk10DIWLIU2AHsAY4A71gctfuDJQtAyBLgFct5Jv8jVtMOq9E9LwBfA/9UTNYPDU+ivZaFLLcc5zp+rPErYBsOedySCzUiivMq5JuatcRncCtwwmbgcs0CYkzPcgXVtZA1Q9QS40/gWTrmGeD2kAXEeNGhkJca1HOry0vox+x/xbDJN5m0XovH3tCwpkngUTqgzuPyQRFv0LyeQ841rO0kHZw3phsk/AfwlGMh6xp2/3Tu88nJxMT+tccf31mcAd4Eli2A+5BlluuZUv5nraaU2j8m41LrzYSE3gImRvBO/WHgWMLv35iHG+AktiUk8+4YPDp5LyGH58nA7ook/stwldFzIGSF1TpXDq+TgQMVSfyaIYeeAyGR3ypy2J8hBw5XJHF+jIScr8ghzlXrSEiBhBjqkBLqkAJ1iKEOKaEOKVCHGOqQEuqQAnWIoQ4poQ4pUIcY6pAS6pACdYihDimhDilQhxjqkBLqkAJ1SOmtkKr1kP5NPm0gIcZDFcunU8ADtI+ElJjrk01xE2kOJKTvjftLA2RczPgmuoT0MWG7Z7+3ONjiu2CDkBBnSIgzJMQZEuIMCXGGhDjDhZA3KpL4nfFhsmIu4p/QaJ3XEnYPrWT0WZ2wi2xXjkS2JDzYOz3in8xbZN/XqpqHuPWvdeLHWv5KSOZTYBWjx6pEGVdzftjmREJCMzFpu1pHISZr1H2cjMS1hrs1khu3mALWk5njDgoPTuNtOuBB4EcHxQdn8XPmJ87/40nguoNJCE7ib2AtHfME8JODyQgdx4VM6/hJTNje9CkHExMyx107Z8R1fnestw311xxMVGg5rtmFzdMsAOIN0XPAq8Be+27hKMReqynegetrpkIIIYQQQgghhBCCceYeGSooyIk/ceIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBlack);
export default __webpack_public_path__ + "static/media/Upload-black.9a2144faacd0356bd3ad778c410a20d1.svg";
export { ForwardRef as ReactComponent };